let cartSpan = document.getElementById("custom-item-count")
localStorage.setItem('cartCount', `${cartSpan.innerHTML}`)

let observer = new MutationObserver(function(mutations) {  
  mutations.forEach(mutation => {
    localStorage.setItem('cartCount', `${cartSpan.innerHTML}`);
  })      
});

var config = {characterData: false, childList: true, attributes: false};
observer.observe(cartSpan, config);

// WEBFLOW CODE
/*
window.onload = function(){
  let cartEl = document.getElementsByClassName('thb-item-count')[0]
  let itemCount = localStorage.getItem('cartCount')
  cartEl.innerHTML = `${itemCount}`
  //console.log(itemCount)
}
*/


